import * as url from "../url.helper";

import { post } from "../api.helper";

export const getIndustry = data => post(url.INDUSTRY_LIST, data);



